import { NotificationStoreInstance } from '@common/stores';
import { ServiceMethodOptions } from './types';

export class ServiceHelper {
  static showError(defaultMessage: string, options?: ServiceMethodOptions) {
    if (!options || options.showError === undefined || options?.showError)
      NotificationStoreInstance.error(
        options && options.errorMessage ? options.errorMessage : defaultMessage,
      );
  }

  static showSuccess(defaultMessage: string, options?: ServiceMethodOptions) {
    if (options?.showSuccess)
      NotificationStoreInstance.success(
        options.successMessage ? options.successMessage : defaultMessage,
      );
  }

  static getTagForOptions(defaultTag: string, options?: ServiceMethodOptions) {
    return (options && (options.promiseArea || defaultTag)) || defaultTag;
  }
}
